// extracted by mini-css-extract-plugin
export var bodyRow = "_dv-d";
export var cardColumns = "_dv-e";
export var ellipsesOverflow = "_dv-2";
export var flatBottomCorners = "_dv-3";
export var flatTopCorners = "_dv-4";
export var headerActionsDropdown = "_dv-f";
export var headerBottomRow = "_dv-c";
export var headerTopRow = "_dv-b";
export var orderDetailsWrapper = "_dv-0";
export var orderInfoContainer = "_dv-1";
export var productDetails = "_dv-9";
export var productImage = "_dv-5";
export var responsiveTable = "_dv-8";
export var shipmentContainer = "_dv-a";
export var tableBottomLeft = "_dv-6";
export var tableBottomRight = "_dv-7";
export var trackingLink = "_dv-g";